import { SDKConfig, OfferWallOptions, Offer, DisplayAdOptions, AdResponse,RewardBalanceOptions,RewardBalanceResponse } from './types';
import { AuthManager } from './core/auth';
import { AdsManager } from './core/ads';
import { OfferManager } from './core/offers';

class K2SDK {
  private static instance: K2SDK | null = null;
  private authManager: AuthManager;
  private adsManager: AdsManager;
  private offerManager: OfferManager;
  private initialized = false;

  private constructor(config: SDKConfig) {
    if (!config.apiKey) {
      throw new Error('API Key is required');
    }

    this.authManager = new AuthManager(config);
    this.adsManager = new AdsManager(config);
    this.offerManager = new OfferManager(config);
  }

  static async initialize(config: SDKConfig): Promise<K2SDK> {
    if (!K2SDK.instance) {
      K2SDK.instance = new K2SDK(config);
      try {
        const isAuthenticated = await K2SDK.instance.authManager.initialize();
        if (!isAuthenticated) {
          throw new Error('Authentication failed');
        }
        K2SDK.instance.initialized = true;
      } catch (error) {
        K2SDK.instance = null;
        throw new Error(`SDK initialization failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
      }
    }
    return K2SDK.instance;
  }

  static getInstance(): K2SDK {
    if (!K2SDK.instance || !K2SDK.instance.initialized) {
      throw new Error('SDK not initialized. Call K2SDK.initialize(config) first');
    }
    return K2SDK.instance;
  }

  getTelegramUserId(): string {
    const userId = this.offerManager.getTelegramUserId();
    if (!userId) {
      throw new Error('Telegram platform not detected. Run this on Telegram to get ID');
    }
    return userId;
  }
  
  isTelegramWebAppAvailable(): boolean {
    return this.offerManager.isWebAppAvailable();
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  static reset(): void {
    K2SDK.instance = null;
  }

  async markActionComplete(advertiserId: string, idToken: string,autoClose: boolean = false): Promise<Offer[]> {
    return await this.offerManager.markActionComplete(advertiserId, idToken, autoClose);
  }
}

export default K2SDK;

if (typeof module !== 'undefined' && module.exports) {
  module.exports = K2SDK;
}